import React, { lazy } from 'react';

// components
import HomeIcon from '@mui/icons-material/Home';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import KeyIcon from '@mui/icons-material/Key';
import CodeIcon from '@mui/icons-material/Code';
import JsonIcon from '../commons/components/JsonIcon/JsonIcon';
import MarkdownIcon from '../commons/components/MarkdownIcon/MakrdownIcon';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon/SvgIcon';
import Home from '../pages/Home/Home';
import routeMeta, { RouteMeta } from './config.routeMeta';

// lazy load
const Ontology = lazy(() => import('../pages/Ontology/Ontology'));
const JsonPage = lazy(() => import('../pages/JSON/JsonPage'));
const MarkdownPage = lazy(() => import('../pages/Markdown/MarkdownPage'));
const SparqlPage = lazy(() => import('../pages/Sparql/SparqlPage'));
const AuthorityPage = lazy(() => import('../pages/Authority/AuthorityPage'));
const CryptoPage = lazy(() => import('../pages/Crypto/CryptoPage'));

export interface IRoute {
  id: string;
  label: string;
  path: string;
  public: boolean;
  showInMenu?: boolean;
  authority: string[];
  component: React.FC<any>;
  childMenu?: IRoute[];
  icon: OverridableComponent<SvgIconTypeMap> & { muiName: string };
}

const componentMap: { [key: string]: React.FC<any> } = {
  'route-01': Home,
  'route-02': Ontology,
  'route-03': JsonPage,
  'route-04': MarkdownPage,
  'route-07': SparqlPage,
  'route-05': AuthorityPage,
  'route-06': CryptoPage,
};

const iconMap: {
  [key: string]: OverridableComponent<SvgIconTypeMap> & { muiName: string };
} = {
  'route-01': HomeIcon,
  'route-02': ScatterPlotIcon,
  'route-03': JsonIcon,
  'route-04': MarkdownIcon,
  'route-07': CodeIcon,
  'route-05': AdminPanelSettingsIcon,
  'route-06': KeyIcon,
};

const buildRoute = (meta: RouteMeta): IRoute => ({
  ...meta,
  component: componentMap[meta.id],
  childMenu: [],
  icon: iconMap[meta.id],
});

const routesPage: IRoute[] = routeMeta.map(buildRoute);

export default routesPage;
